import { render, staticRenderFns } from "./paymentHistory.vue?vue&type=template&id=6a1fa100&scoped=true&"
import script from "./paymentHistory.vue?vue&type=script&lang=js&"
export * from "./paymentHistory.vue?vue&type=script&lang=js&"
import style0 from "./paymentHistory.vue?vue&type=style&index=0&id=6a1fa100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1fa100",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a1fa100')) {
      api.createRecord('6a1fa100', component.options)
    } else {
      api.reload('6a1fa100', component.options)
    }
    module.hot.accept("./paymentHistory.vue?vue&type=template&id=6a1fa100&scoped=true&", function () {
      api.rerender('6a1fa100', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/payments/paymentHistory.vue"
export default component.exports